module.exports = "<div class=\"conteudo-about\"> <h1>Ahura</h1> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/core/components/about/about.component.html
// module id = 1124
// module chunks = 7